import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FadeUp, RevealLine } from "./AnimatedSection";
import { useLanguage } from "@/context/LanguageContext";

export const FAQSection = () => {
  const { t } = useLanguage();

  return (
    <section id="faq" data-testid="faq-section" className="relative py-28 md:py-36 bg-[#0A0A0A] overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-brand-red/[0.07] via-transparent to-transparent animate-float" />
      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10">
        <p className="text-brand-red text-xs font-mono tracking-[0.25em] font-semibold uppercase mb-4">{t.faq.label}</p>
        <h2 className="font-heading text-4xl md:text-5xl font-bold text-white tracking-tight mb-14">
          <RevealLine text={t.faq.title} />
        </h2>

        <FadeUp>
          <Accordion type="single" collapsible className="w-full">
            {t.faq.items.map((item, i) => (
              <AccordionItem key={item.q} value={`item-${i}`} className="border-white/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-heading text-white text-base md:text-lg font-semibold py-6 hover:no-underline hover:text-neutral-200"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="text-neutral-400 text-[15px] leading-relaxed pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>
      </div>
    </section>
  );
};
